<template>
  <span style="text-align:left">
    <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
      <v-input
        :value="value"
        required
        :rules="crud.evalrules(campo)"
        :hint="T(campo.cmp_dica)"
        persistent-hint
      >
        <el-input-number
          class="mt-3"
          v-bind:value="preLoad(value)"
          v-on:input="event => $emit('input', preUpdate(event))"
          :controls="getComponentParam('controls') || true"
          :controls-position="getComponentParam('controls-position') || 'right'"
          size="small"
          :min="
            getComponentParam('min') !== null ? getComponentParam('min') * 1 : 0
          "
          :max="
            getComponentParam('max') !== null
              ? getComponentParam('max') * 1
              : 100
          "
          :step="getComponentParam('step') || 1"
        ></el-input-number>
      </v-input>
    </template>

    <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
      <span :class="{ 'text-xs-center': modo == 'list' }">{{
        displayvalue
      }}</span>
    </template>

    <template v-if="modo == 'filtro'">
      <v-input
        hide-details
        :value="value"
        required
        :rules="crud.evalrules(campo)"
        :hint="T(campo.cmp_dica)"
        persistent-hint
      >
        <el-input-number
          v-bind:value="preLoad(value)"
          v-on:input="event => $emit('input', preUpdate(event))"
          :controls="getComponentParam('controls') || true"
          :controls-position="getComponentParam('controls-position') || 'right'"
          size="small"
          :min="
            getComponentParam('min') !== null
              ? getComponentParam('min') * 1
              : -Infinity
          "
          :max="
            getComponentParam('max') !== null
              ? getComponentParam('max') * 1
              : Infinity
          "
          :step="getComponentParam('step') || 1"
        ></el-input-number>
      </v-input>
    </template>
  </span>
</template>

<script>
try {
  var _baseComponent = require("@/lib/componente/_base.vue").default;
} catch (err) {
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}

export default {
  extends: _baseComponent,

  data() {
    return {};
  },
  methods: {
    preUpdate(myval) {
      return myval == 0 ? 0 : myval;
    }
  }
};
</script>

<style scoped>
.decimalnumber input {
  font-size: 24px !important;
  height: 42px;
  line-height: 42px;
  background-color: red;
  margin-top: 13px;
  border-bottom: solid #ccc 1px;
  background-color: #fcfcfc;
}
.decimalnumberfiltro input {
  font-size: 18px !important;
  height: 36px;
  line-height: 36px;
  background-color: red;
  border-bottom: solid #ccc 1px;
  background-color: #fcfcfc;
  margin: 2px;
}
</style>
